import { useTranslation } from '@frontend/i18n';

export const useCareCreditTranslations = () => {
  return useTranslation('payments-care-credit');
};
